import { Analytics } from "@vercel/analytics/react";
import { useLocation } from "react-router-dom";

/**
 * Web Analytics Vercel: con React Router serve passare route/path
 * così ogni cambio di pagina registra un pageview.
 * Abilita "Web Analytics" nel progetto su vercel.com → Settings → Analytics.
 */
export function VercelAnalytics() {
  const { pathname, search, hash } = useLocation();
  const path = `${pathname}${search}${hash}`;

  return <Analytics route={pathname} path={path} />;
}
